import { isSwedishWorkflow, config } from '@/services/config.service';

export enum Features {
  BankIdLogin = 'bankIdLogin',
}

const featureFlags: Record<Features, boolean> = {
  bankIdLogin: isSwedishWorkflow && config.env === 'development',
};

export const useFeatureFlag = (feature: Features) => featureFlags[feature];
